export enum ProcedureTypeEnum {
  ProcedureCenter = 1,
  RSSTest = 2,
  EPSTest = 3,
  KEChecklist = 4,
  EPSDrawings = 5,
  RadSurvey = 6
}
